module.exports = __webpack_public_path__ + "img/tpc-web-7.ca2c3f3f.webp";